import { render } from "./ContactRep.vue?vue&type=template&id=ddb0a426"
import script from "./ContactRep.vue?vue&type=script&lang=js"
export * from "./ContactRep.vue?vue&type=script&lang=js"

import "./ContactRep.vue?vue&type=style&index=0&id=ddb0a426&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__